import {WebsiteSidebarSimpleItem} from "./website-sidebar-simple-item.model";

export interface IWebsiteSidebarSimpleItemBuilder {
  setImg: (img: string) => WebsiteSidebarSimpleItemBuilder;
  setIcon: (icon: string) => WebsiteSidebarSimpleItemBuilder;
  setPath: (path: string) => WebsiteSidebarSimpleItemBuilder;
  setActions: (actions: string[]) => WebsiteSidebarSimpleItemBuilder;
  setDisabled: (disabled: boolean) => WebsiteSidebarSimpleItemBuilder;
  setNotification: (notification: boolean) => WebsiteSidebarSimpleItemBuilder;
  setBeta: (beta: boolean) => WebsiteSidebarSimpleItemBuilder;
  build: () => WebsiteSidebarSimpleItem;
}

export class WebsiteSidebarSimpleItemBuilder implements IWebsiteSidebarSimpleItemBuilder {
  private readonly product: WebsiteSidebarSimpleItem;

  constructor(name: string, label: string) {
    this.product = new WebsiteSidebarSimpleItem(name, label);
  }

  setImg(img: string): WebsiteSidebarSimpleItemBuilder {
    this.product.img = img;
    return this;
  }

  setIcon(icon: string): WebsiteSidebarSimpleItemBuilder {
    this.product.icon = icon;
    return this;
  }

  setPath(path: string): WebsiteSidebarSimpleItemBuilder {
    this.product.path = path;
    return this;
  }

  setActions(actions: string[]): WebsiteSidebarSimpleItemBuilder {
    this.product.setActions(actions);
    return this;
  }

  setDisabled(disabled: boolean): WebsiteSidebarSimpleItemBuilder {
    this.product.disabled = disabled;
    return this;
  }

  setNotification(notification: boolean): WebsiteSidebarSimpleItemBuilder {
    this.product.notification = notification;
    return this;
  }

  setBeta(beta: boolean): WebsiteSidebarSimpleItemBuilder {
    this.product.beta = beta;
    return this;
  }
  setExternalLink(externalLink: boolean): WebsiteSidebarSimpleItemBuilder {
    this.product.externalLink = externalLink;
    return this;
  }
  setShowUpgrade(showUpgrade: boolean): WebsiteSidebarSimpleItemBuilder {
    this.product.showUpgrade = showUpgrade;
    return this;
  }

  build(): WebsiteSidebarSimpleItem {
    return this.product;
  }
}
